module.exports = __webpack_public_path__ + "static/ai-5-sq-3161dae0318abe027edb8bb16a21850c.png";